@if (tabs && tabs.length) {
  <mat-tab-group
    class="nav-tabs"
    color="primary"
    [stretchTabs]="true"
    [selectedIndex]='activeTabIndex'
    (selectedIndexChange)="selectTab($event)"
    #tabsGroup
    >
    @for (tab of tabs; track tab) {
      <mat-tab
        class="nav-tab"
        (click)="selectTab(tab)">
        <ng-template mat-tab-label>
          @if (tab.icon) {
            <mat-icon>{{ tab.icon }}</mat-icon>
          }
          {{tab.name | uppercase}}
        </ng-template>
      </mat-tab>
    }
  </mat-tab-group>
}
